import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Nav } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';
import { FormattedMessage } from 'react-intl';

export class NavMenu extends Component {
  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  componentDidMount() {
    this.setState({
      path: window.location.pathname
    });
  }

  componentDidUpdate() {
    if (this.state.path !== window.location.pathname) {
      this.setState({
        path: window.location.pathname
      });
    }
  }

  render () {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
          <Container className="topcont">
            <NavbarBrand className='logo' tag={Link} to="/" onClick={() => this.setState({collapsed: true/*, path: window.location.pathname*/})}></NavbarBrand>
            <div style={{flex: "auto"}}></div>
            <NavItem className='nav'>
              <NavLink tag={Link} className={`text-dark ${this.state.path?.startsWith("/booking")?"react-calendar__tile--active":"btn-book"}`} to="/booking" onClick={() => this.setState({collapsed: true/*, path: window.location.pathname*/})}><FormattedMessage id="booking"/></NavLink>
            </NavItem>
            <div class="mainmenudiv">
              <LoginMenu type="loginimages">
              </LoginMenu>
              <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            </div>
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <Nav className="navbar-nav flex-grow ml-auto">
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/calendar" onClick={() => this.setState({collapsed: true})}><FormattedMessage id="my_calendar"/></NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/orders" onClick={() => this.setState({collapsed: true})}><FormattedMessage id="my_bookings"/></NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/configcompany" onClick={() => this.setState({collapsed: true})}><FormattedMessage id="my_company"/></NavLink>
                </NavItem>
                <LoginMenu type="logintext">
                </LoginMenu>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}
